/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../graphql.generated'

import { EnrollmentFragmentDoc } from '../participant/patientQueries.generated'

const defaultOptions = {} as const
export type HomeViewParticipantIndicatorsFragment = {
  __typename?: 'Patient'
  uid: string
  indicators?: {
    __typename?: 'PatientIndicators'
    lastViewedAt?: Date | null
    suicidal?: boolean | null
    overdueHealthQuestionnaire?: boolean | null
    daysDisengaged?: { __typename?: 'DaysDisengagedIndicator'; days: number; level: Types.AppActivityLevel } | null
    risk?: { __typename?: 'RiskIndicator'; level: Types.RiskLevel; trend: Types.AssessmentTrend } | null
    currentOrUpcomingCall?: {
      __typename?: 'VideoCall'
      id: string
      callType: Types.VideoCallType
      startTime: Date
      endTime: Date
    } | null
    completedCallAwaitingNote?: {
      __typename?: 'VideoCall'
      id: string
      callType: Types.VideoCallType
      startTime: Date
    } | null
    newMessages?: { __typename?: 'PatientNewMessageIndicator'; count: number } | null
    monthlySummaryNotes?: {
      __typename?: 'MonthlySummaryNoteIndicator'
      count: number
      showIndicator: boolean
      showToast: boolean
    } | null
  } | null
}

export type HomeViewParticipantFragment = {
  __typename?: 'Patient'
  uid: string
  email?: string | null
  firstname?: string | null
  lastname?: string | null
  intakeCallTime?: Date | null
  timezone?: string | null
  language?: string | null
  details?: Types.JSONObject | null
  enrollment: {
    __typename?: 'Enrollment'
    id: string
    state: Types.EnrollmentState
    programID: string
    programStartDate?: Date | null
    lastStateTransitionAt: Date
    createdAt: Date
    enrolledFromPreviousAdvancedProgram: boolean
  }
  tags?: Array<{ __typename?: 'PatientTag'; id: string; name: string; createdAt: Date }> | null
  careTeam?: Array<{ __typename?: 'CareTeamMember'; coachID: string; isPrimary: boolean }> | null
  indicators?: {
    __typename?: 'PatientIndicators'
    lastViewedAt?: Date | null
    suicidal?: boolean | null
    overdueHealthQuestionnaire?: boolean | null
    daysDisengaged?: { __typename?: 'DaysDisengagedIndicator'; days: number; level: Types.AppActivityLevel } | null
    risk?: { __typename?: 'RiskIndicator'; level: Types.RiskLevel; trend: Types.AssessmentTrend } | null
    currentOrUpcomingCall?: {
      __typename?: 'VideoCall'
      id: string
      callType: Types.VideoCallType
      startTime: Date
      endTime: Date
    } | null
    completedCallAwaitingNote?: {
      __typename?: 'VideoCall'
      id: string
      callType: Types.VideoCallType
      startTime: Date
    } | null
    newMessages?: { __typename?: 'PatientNewMessageIndicator'; count: number } | null
    monthlySummaryNotes?: {
      __typename?: 'MonthlySummaryNoteIndicator'
      count: number
      showIndicator: boolean
      showToast: boolean
    } | null
  } | null
}

export type FetchParticipantsForHomeViewQueryVariables = Types.Exact<{
  query?: Types.InputMaybe<Types.Scalars['String']['input']>
  coachIDs?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>
  states?: Types.InputMaybe<Array<Types.EnrollmentState> | Types.EnrollmentState>
  showPriorityIndicators: Types.Scalars['Boolean']['input']
  showDevInfo: Types.Scalars['Boolean']['input']
}>

export type FetchParticipantsForHomeViewQuery = {
  __typename?: 'Query'
  searchPatientsV2: {
    __typename?: 'SearchPatientsResponse'
    patients: Array<{
      __typename?: 'Patient'
      uid: string
      email?: string | null
      firstname?: string | null
      lastname?: string | null
      intakeCallTime?: Date | null
      timezone?: string | null
      language?: string | null
      details?: Types.JSONObject | null
      enrollment: {
        __typename?: 'Enrollment'
        id: string
        state: Types.EnrollmentState
        programID: string
        programStartDate?: Date | null
        lastStateTransitionAt: Date
        createdAt: Date
        enrolledFromPreviousAdvancedProgram: boolean
      }
      tags?: Array<{ __typename?: 'PatientTag'; id: string; name: string; createdAt: Date }> | null
      careTeam?: Array<{ __typename?: 'CareTeamMember'; coachID: string; isPrimary: boolean }> | null
      indicators?: {
        __typename?: 'PatientIndicators'
        lastViewedAt?: Date | null
        suicidal?: boolean | null
        overdueHealthQuestionnaire?: boolean | null
        daysDisengaged?: { __typename?: 'DaysDisengagedIndicator'; days: number; level: Types.AppActivityLevel } | null
        risk?: { __typename?: 'RiskIndicator'; level: Types.RiskLevel; trend: Types.AssessmentTrend } | null
        currentOrUpcomingCall?: {
          __typename?: 'VideoCall'
          id: string
          callType: Types.VideoCallType
          startTime: Date
          endTime: Date
        } | null
        completedCallAwaitingNote?: {
          __typename?: 'VideoCall'
          id: string
          callType: Types.VideoCallType
          startTime: Date
        } | null
        newMessages?: { __typename?: 'PatientNewMessageIndicator'; count: number } | null
        monthlySummaryNotes?: {
          __typename?: 'MonthlySummaryNoteIndicator'
          count: number
          showIndicator: boolean
          showToast: boolean
        } | null
      } | null
    }>
  }
}

export type RefreshParticipantIndicatorsQueryVariables = Types.Exact<{
  uids: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']
  showPriorityIndicators: Types.Scalars['Boolean']['input']
}>

export type RefreshParticipantIndicatorsQuery = {
  __typename?: 'Query'
  patients: Array<{
    __typename?: 'Patient'
    uid: string
    indicators?: {
      __typename?: 'PatientIndicators'
      lastViewedAt?: Date | null
      suicidal?: boolean | null
      overdueHealthQuestionnaire?: boolean | null
      daysDisengaged?: { __typename?: 'DaysDisengagedIndicator'; days: number; level: Types.AppActivityLevel } | null
      risk?: { __typename?: 'RiskIndicator'; level: Types.RiskLevel; trend: Types.AssessmentTrend } | null
      currentOrUpcomingCall?: {
        __typename?: 'VideoCall'
        id: string
        callType: Types.VideoCallType
        startTime: Date
        endTime: Date
      } | null
      completedCallAwaitingNote?: {
        __typename?: 'VideoCall'
        id: string
        callType: Types.VideoCallType
        startTime: Date
      } | null
      newMessages?: { __typename?: 'PatientNewMessageIndicator'; count: number } | null
      monthlySummaryNotes?: {
        __typename?: 'MonthlySummaryNoteIndicator'
        count: number
        showIndicator: boolean
        showToast: boolean
      } | null
    } | null
  }>
}

export const HomeViewParticipantIndicatorsFragmentDoc = gql`
  fragment HomeViewParticipantIndicators on Patient {
    uid
    indicators {
      newMessages {
        count
      }
      suicidal
      monthlySummaryNotes {
        count
        showIndicator
        showToast
      }
      overdueHealthQuestionnaire
      ... @include(if: $showPriorityIndicators) {
        daysDisengaged {
          days
          level
        }
        lastViewedAt
        risk {
          level
          trend
        }
        currentOrUpcomingCall {
          id
          callType
          startTime
          endTime
        }
        completedCallAwaitingNote {
          id
          callType
          startTime
        }
      }
    }
  }
`
export const HomeViewParticipantFragmentDoc = gql`
  fragment HomeViewParticipant on Patient {
    uid
    email
    firstname
    lastname
    ...HomeViewParticipantIndicators
    intakeCallTime
    timezone
    language @include(if: $showDevInfo)
    details @include(if: $showDevInfo)
    enrollment {
      ...Enrollment
    }
    tags {
      id
      name
      createdAt
    }
    careTeam {
      coachID
      isPrimary
    }
  }
  ${HomeViewParticipantIndicatorsFragmentDoc}
  ${EnrollmentFragmentDoc}
`
export const FetchParticipantsForHomeViewDocument = gql`
  query fetchParticipantsForHomeView(
    $query: String
    $coachIDs: [ID!]
    $states: [EnrollmentState!]
    $showPriorityIndicators: Boolean!
    $showDevInfo: Boolean!
  ) {
    searchPatientsV2(
      query: $query
      coachIDs: $coachIDs
      states: $states
      sources: []
      statesOfResidence: []
      page: 0
      pageSize: 499
      includeOnlyPrimaryPatients: false
    ) {
      patients {
        ...HomeViewParticipant
      }
    }
  }
  ${HomeViewParticipantFragmentDoc}
`

/**
 * __useFetchParticipantsForHomeViewQuery__
 *
 * To run a query within a React component, call `useFetchParticipantsForHomeViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchParticipantsForHomeViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchParticipantsForHomeViewQuery({
 *   variables: {
 *      query: // value for 'query'
 *      coachIDs: // value for 'coachIDs'
 *      states: // value for 'states'
 *      showPriorityIndicators: // value for 'showPriorityIndicators'
 *      showDevInfo: // value for 'showDevInfo'
 *   },
 * });
 */
export function useFetchParticipantsForHomeViewQuery(
  baseOptions: Apollo.QueryHookOptions<FetchParticipantsForHomeViewQuery, FetchParticipantsForHomeViewQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FetchParticipantsForHomeViewQuery, FetchParticipantsForHomeViewQueryVariables>(
    FetchParticipantsForHomeViewDocument,
    options
  )
}
export function useFetchParticipantsForHomeViewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchParticipantsForHomeViewQuery,
    FetchParticipantsForHomeViewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FetchParticipantsForHomeViewQuery, FetchParticipantsForHomeViewQueryVariables>(
    FetchParticipantsForHomeViewDocument,
    options
  )
}
export type FetchParticipantsForHomeViewQueryHookResult = ReturnType<typeof useFetchParticipantsForHomeViewQuery>
export type FetchParticipantsForHomeViewLazyQueryHookResult = ReturnType<
  typeof useFetchParticipantsForHomeViewLazyQuery
>
export type FetchParticipantsForHomeViewQueryResult = Apollo.QueryResult<
  FetchParticipantsForHomeViewQuery,
  FetchParticipantsForHomeViewQueryVariables
>
export const RefreshParticipantIndicatorsDocument = gql`
  query refreshParticipantIndicators($uids: [ID!]!, $showPriorityIndicators: Boolean!) {
    patients(uids: $uids) {
      ...HomeViewParticipantIndicators
    }
  }
  ${HomeViewParticipantIndicatorsFragmentDoc}
`

/**
 * __useRefreshParticipantIndicatorsQuery__
 *
 * To run a query within a React component, call `useRefreshParticipantIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefreshParticipantIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefreshParticipantIndicatorsQuery({
 *   variables: {
 *      uids: // value for 'uids'
 *      showPriorityIndicators: // value for 'showPriorityIndicators'
 *   },
 * });
 */
export function useRefreshParticipantIndicatorsQuery(
  baseOptions: Apollo.QueryHookOptions<RefreshParticipantIndicatorsQuery, RefreshParticipantIndicatorsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<RefreshParticipantIndicatorsQuery, RefreshParticipantIndicatorsQueryVariables>(
    RefreshParticipantIndicatorsDocument,
    options
  )
}
export function useRefreshParticipantIndicatorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RefreshParticipantIndicatorsQuery,
    RefreshParticipantIndicatorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<RefreshParticipantIndicatorsQuery, RefreshParticipantIndicatorsQueryVariables>(
    RefreshParticipantIndicatorsDocument,
    options
  )
}
export type RefreshParticipantIndicatorsQueryHookResult = ReturnType<typeof useRefreshParticipantIndicatorsQuery>
export type RefreshParticipantIndicatorsLazyQueryHookResult = ReturnType<
  typeof useRefreshParticipantIndicatorsLazyQuery
>
export type RefreshParticipantIndicatorsQueryResult = Apollo.QueryResult<
  RefreshParticipantIndicatorsQuery,
  RefreshParticipantIndicatorsQueryVariables
>
